import { methods } from "../../utils/axios";

export default class SearchAPI {
  // Lupa de la barra superior: colaboradores y (superadmin) empresas.
  static search(q) {
    return methods.get('/search', { q });
  }
}
